// extracted by mini-css-extract-plugin
export default {"base":"vp_F0Otw","date":"vp_YYkBn","time":"vp_sa2KL"};